"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAreaRole = exports.AREA_ROLES = exports.AREAS = void 0;
exports.AREAS = {
    CMS: 'CMS',
    PROMO_CODES: 'PromoCodes',
    RULES: 'Rules',
    VENDORS: 'Vendor',
    NONE: 'None',
};
exports.AREA_ROLES = {
    ADMIN: 'Admin',
    READ_ONLY: 'ReadOnly',
};
const parseAreaRole = (claim) => {
    const [area = 'Unknown', role = 'Unknown'] = claim.split('.');
    return { area, role };
};
exports.parseAreaRole = parseAreaRole;
